import * as React from "react";

function SvgViewMany(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}><path d="M12.5 12.5H0V0h12.5v12.5zM31.2 0H18.8v12.5h12.5V0zM50 0H37.5v12.5H50V0zM12.5 18.8H0v12.5h12.5V18.8zm18.7 0H18.8v12.5h12.5V18.8zm18.8 0H37.5v12.5H50V18.8zM12.5 37.5H0V50h12.5V37.5zm18.7 0H18.8V50h12.5V37.5zm18.8 0H37.5V50H50V37.5z" /></svg>;
}

export default SvgViewMany;